
export const VideoModal = {
  onLoad: function () {
    if ($('.video-modal').length) {
      $('.video-modal').on('show.bs.modal', function (e) {
        // then make video autoplay
        const modal_video_iframe = $('#' + e.target.id).find('iframe');
        let video_src = modal_video_iframe.attr('data-src');
        video_src += '?rel=0&autoplay=1';
        modal_video_iframe.attr('src', video_src);
      });
      $('.video-modal').on('hide.bs.modal', function (e) {
        // then pause video
        const modal_video_iframe = $('#' + e.target.id).find('iframe');
        // let video_src = modal_video_iframe.attr('src');
        // video_src = video_src.substring(0, video_src.indexOf('?'));
        modal_video_iframe.attr('src', '');
      });
    }
  },
}



// WEBPACK FOOTER //
// ./scripts/layouts/VideoModal.js